<template>
  <div>
    <div>
      <h2 style="margin-top: 0">留言管理</h2>
      <el-divider></el-divider>
    </div>
    <div style="height: 600px">
      <div v-for="item of user">
        <div style="display: flex;height: 30px">
          <img :src="item.user[0].headPortrait" width="30px" height="30px">
          <div style="display: flex;line-height: 30px;margin-left: 10px">{{ item.user[0].name }}</div>&nbsp;&nbsp;&nbsp;
          <div style="display: flex;line-height: 30px"><font style="color: gray;font-size: 5px">{{
              item.createTime
            }}</font>
          </div>

          <div style="margin: 0 0 0 auto">
            <div v-if="item.isReply===0">
              <span @click="repleymes(item)" style="color: skyblue">回复 </span> |<span
              @click="deletemes(item.id)" style="color: red"> 删除</span>
            </div>
            <div v-else>
              <span style="color: green">已回复 </span> |<span @click="deletemes(item.id)"
                                                            style="color: red"> 删除</span>
            </div>
          </div>
        </div>

        <div style="margin-left: 25px;width: 850px">
          <p>{{ item.content }}</p>
        </div>

        <el-divider></el-divider>
      </div>
    </div>
    <div>
      <div style="background-color: transparent;border: none">
        <el-pagination @current-change="currentChange"
                       background
                       layout="prev, pager, next"
                       :total="page.count">
        </el-pagination>
      </div>
    </div>

    <!--编辑框      -->
    <el-dialog title="回复" width="700px" :visible.sync="editDialogVisible"
               centerp center>
      <el-form :model="editForm" ref="editForm" label-width="150px"
               class="demo-ruleForm"
               style="margin-left: 20px;">

        <el-form-item label="留言内容：" prop="name">
          <el-input v-model="editForm.content" type="textarea" size="medium" resize="none" readonly
                    style="width: 400px"></el-input>
        </el-form-item>

        <el-form-item label="回复内容：" prop="name">
          <el-input v-model="editForm.replyContent" show-word-limit type="textarea" resize="none" size="medium"
                    maxlength="100"
                    style="width: 400px;"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" @click="confirmed()">确定</el-button>
          <el-button size="small" @click="cancel('editRules')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  name: "LeaveMsgManager",
  data() {
    return {
      editDialogVisible: false,
      page: {
        currentPage: 0,
        count: null,
      },
      editForm: {
        id: '',
        content: '',
        replyContent: '',
      },
      admin: {
        adminId: null,
      },
      user: [
        {
          user: [{
            headPortrait: null,
            name: null,
          }],
          id: null,
          createTime: null,
          content: '',
          isReply: null,
          replyContent: null,
          updateTime: null
        },
      ],
      //管理员登录信息
      adminInfo:{}
    }
  },
  methods: {
    getAllMsg() {//获取留言信息总数据
      let that = this;
      request({
        url: "/Leave/msg",
        method: 'get',
        params: {
          page: that.page.currentPage
        }
      }).then(response => {
        let data = response.data.data;
        for (let i = 0; i < data.length; i++) {
          data[i].user[0].headPortrait = base_url+'/getImage/' + data[i].user[0].headPortrait;
          data[i].createTime = that.handTime(response.data.data[i].createTime);
          data[i].updateTime = that.handTime(response.data.data[i].updateTime);
        }
        that.user = data;
        that.getCount();
      });
    },
    getCount() {//获取总数据条数
      let that = this;
      request({
        url: "/Leave/count",
        method: 'get',
      }).then(response => {
        let num1 = Math.floor(response.data / 5);
        if (response.data % 5 !== 0) {
          num1++;
        }
        that.page.count = num1 * 10;
      });
    },
    handTime(data) {//处理时间 以多少天之前、多少秒之前...展示
      let currentTime = new Date().getTime();
      let recentTime = new Date(
        data.substr(0, 4),
        parseInt(data.substr(5, 2)) - 1,
        data.substr(8, 2),
        data.substr(11, 2),
        data.substr(14, 2),
        data.substr(17, 2),
      ).getTime();

      let time = currentTime - recentTime;
      let seconds = parseInt(time / 1000 + "");//秒
      let targetTime = null;
      if (seconds >= 60 * 60 * 24 * 30 * 12) {//31,104,000
        targetTime = parseInt(seconds / (60 * 60 * 24 * 30 * 12)) + "年前";
      } else if (seconds >= 60 * 60 * 24 * 30) {//2,592,000
        targetTime = parseInt(seconds / (60 * 60 * 24 * 30)) + "月前";
      } else if (seconds >= 60 * 60 * 24) {//86,400
        targetTime = parseInt(seconds / (60 * 60 * 24)) + "天前";
      } else if (seconds >= 60 * 60) {//3,600
        targetTime = parseInt(seconds / (60 * 60)) + "小时前";
      } else if (seconds >= 60) {//60
        targetTime = parseInt(seconds / 60) + "分前";
      } else {
        targetTime = seconds + "秒前";
      }
      return targetTime;
    },
    deletemes(id) {//实现删除功能
      let that = this;
      this.$confirm('此操作将逻辑删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: '/Leave/delete',
          method: 'get',
          params: {
            id: id,
            adminInfo:this.adminInfo
          }
        }).then(response => {
          if (response.data.flag) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'error',
              message: '删除失败!'
            });
          }
          that.getAllMsg();
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    repleymes(data) {//实现回复功能
      this.editForm.id = data.id;
      this.editForm.content = data.content;
      var admin = JSON.parse(window.sessionStorage.getItem("adminInfo"));
      this.admin.adminId = admin.id;
      this.editDialogVisible = true;
    },
    confirmed() {//实现回复确定按钮
      let that = this;
      request({
        url: '/Leave/reply',
        method: 'post',
        params: {
          id: that.editForm.id,
          adminId: that.admin.adminId,
          content: that.editForm.replyContent,
          adminInfo:this.adminInfo
        }
      }).then(response => {
        if (response.data.flag) {
          that.getAllMsg();
          this.$message({
            type: 'success',
            message: '回复成功'
          });
          that.editDialogVisible = false;
        } else {
          this.$notify.error({
            title: '回复',
            duration: 4000,
            message: '回复失败'
          });
        }
      })
    },
    cancel() {//实现回复取消功能
      this.editDialogVisible = false;
    },
    currentChange(value) {
      this.page.currentPage = (value - 1) * 5;
      this.getAllMsg();
    }
  },
  mounted() {//获得初始数据
    let adminInfo = JSON.parse(window.sessionStorage.getItem("adminInfo"));
    this.adminInfo = adminInfo;
    this.getAllMsg();
  }
}
</script>
<style scoped>
span:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/LeaveMsgManager.vue